import { render, staticRenderFns } from "./WorkshopsListFilter.vue?vue&type=template&id=f36a447e&scoped=true&"
import script from "./WorkshopsListFilter.vue?vue&type=script&lang=js&"
export * from "./WorkshopsListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36a447e",
  null
  
)

export default component.exports